import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import Button from 'packages/ui/Button';
import { Link } from 'react-router-dom';
import { CustomOrdersUIProvider } from './CustomOrdersContextProvider';

const CustomOrdersList = React.lazy(() => import('./CustomOrders'));

function CustomOrders(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>لیست سفارشات دستی</PageTitle>
        <Button as={Link} type="anchor" to="/custom-orders/new">
          افزودن سفارش دستی
        </Button>
      </PageHeader>
      <Suspense fallback={<Loading />}>
        <CustomOrdersUIProvider>
          <CustomOrdersList {...props} />
        </CustomOrdersUIProvider>
      </Suspense>
    </Page>
  );
}

export default CustomOrders;
